import { render, staticRenderFns } from "./photoCheckCollectList.vue?vue&type=template&id=d5901708&scoped=true&"
import script from "./photoCheckCollectList.vue?vue&type=script&lang=js&"
export * from "./photoCheckCollectList.vue?vue&type=script&lang=js&"
import style0 from "./photoCheckCollectList.vue?vue&type=style&index=0&id=d5901708&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5901708",
  null
  
)

export default component.exports